Namespace('Monitoring.LiveReports.RealtimeMap')

class Monitoring.LiveReports.RealtimeMapSidebarView extends Backbone.View
  template: JST["backbone/templates/monitoring/live_reports/realtime_map/realtime_map_sidebar"]
  className: 'live-report-sidebar'
  id: 'myNav'

  events:
    'click .closebtn': 'close'
    'change .precision-type-checkbox': 'onChangeCheckbox'
    'change select': 'onChangeCombobox'
    'click .sidebar-apply': 'apply'

  initialize: (@options = {}) ->
    @opened = false
    @currentFilterDefinition = @options.filter_definition

  render: ->
    @$el.html(@template(@currentFilterDefinition))
    # TODO use this to select the correct time
    # @$el.find("#realtime_cbo option[value=#{@searchQuery.get('date_from_realtime').value}]").prop('selected', true)

  toggle: ->
    if @opened then @close() else @open()

  open: ->
    @$el.css({ left: "0" })
    @opened = true
    @trigger('open-filter')

  close: ->
    @$el.css({ left: "-250px" })
    @opened = false
    @trigger('close-filter')

  setLayerNames: (layerNames, layerVisibilities) ->
    # layerVisibilities is an object with category names as keys and booleans as values
    layersViewContainer = @$el.find('.layers-checkboxes-container')
    @layersView = new Monitoring.LiveReports.RealtimeMapSidebarLayersView({
      el: layersViewContainer
      layerNames: layerNames
      layerVisibilities: layerVisibilities
    })
    @layersView.render()
    @listenTo(@layersView, 'selected-layer', @onSelectLayer)
    @listenTo(@layersView, 'deselected-layer', @onDeselectLayer)

  onSelectLayer: (layerName) ->
    @trigger('selected-layer', layerName)

  onDeselectLayer: (layerName) ->
    @trigger('deselected-layer', layerName)

  onChangeCheckbox: ->
    @waitAndApply()

  onChangeCombobox: ->
    @waitAndApply()

  waitAndApply: ->
    clearTimeout(@applyTimeout) if @applyTimeout
    @applyTimeout = setTimeout =>
      @apply()
    , 1000

  apply: ->
    @$el.find('.loader').removeClass('hidden')
    @trigger('apply', @currentSettings())

  currentSettings: ->
    fromMinutesAgo = @$el.find('.sidebar-date-selector').val()
    precisionTypes = @$el.find('.precision-type-checkbox:checked').map(() -> @value)
    {
      from_minutes_ago: fromMinutesAgo
      geolocation_precision_types: $.makeArray(precisionTypes)
    }